/**
 * Created by peter on 4/21/16.
 */

const SCALE = 20;

export { SCALE };



// WEBPACK FOOTER //
// ./src/game/graphics.js